export default __webpack_public_path__ + "static/media/messagebutton.1bb996f1.svg";